import { headerAnimations } from "./scripts/animations";
import { initStatement } from "./scripts/statement";
import { initServices } from "./scripts/services";
import { testimonialsSlider } from "./scripts/testimonials";
import { runForm } from "./scripts/form";
import { initSlider } from "./scripts/logo-slider";

document.addEventListener("DOMContentLoaded", () => {
  headerAnimations();
  initStatement();
  initServices();
  testimonialsSlider();
  runForm();
  initSlider();
});
